import { createVanIconComponent } from "./van"

const Shop = createVanIconComponent("shop")
export default Shop
